import axios from 'axios';

class Verihub{
  constructor(
    vAppId
    , vAPIKey
  ){
    this.vAppId = vAppId;
    this.vAPIKey = vAPIKey;
  }

  FaceSearch( vImage ){
    let vData = {
      image: vImage
    }

    return new Promise(
      async(
        resolve
        , reject
      ) => {
        try{
          const vResponse = await axios.post(
            "https://api.test2.facerecognition.suvarna-mi.com/v1/face/search"
            , JSON.stringify( vData )
            , {
              headers: {
                "Content-Type": "application/json"
                , "App-ID": this.vAppId
                , "API-Key": this.vAPIKey
              }
            }
          )

          resolve( vResponse )
        }
        catch( vError ){
          resolve( vError )
        }
      }
    )
  }
}

export{ Verihub }